import { MessageType } from "../enums/MessageType";

export class DQOIMessage {
    customer: string;
    location: string;
    customerId: any;
    locationId: any;
    messageType: MessageType;
    messageData: any;
}